import { Button } from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { Link } from "react-router-dom";
import TutorListPage from "./TutorListPage";

const studentDisplayName = (row) => {
  const buyer = row.buyer;
  if (!buyer) return "-";
  const detailName = buyer.student_detail?.display_name || buyer.studentDetail?.display_name;
  if (detailName && String(detailName).trim()) return String(detailName).trim();
  const full = `${buyer.first_name || ""} ${buyer.last_name || ""}`.trim();
  return full || buyer.email || "-";
};

const schoolYearLabel = (row) => {
  const fromStudent =
    row.buyer?.student_detail?.school_year?.name ||
    row.buyer?.studentDetail?.schoolYear?.name ||
    row.buyer?.student_detail?.schoolYear?.name ||
    row.buyer?.studentDetail?.school_year?.name;
  if (fromStudent) return fromStudent;
  const fromCourse = row.course?.school_year?.name || row.course?.schoolYear?.name;
  return fromCourse || "-";
};

const transformStudent = (row) => ({
  id: row.id,
  buyer_id: row.buyer_id || row.buyer?.id,
  buyer: row.buyer,
  course: row.course?.name ?? "-",
  name: studentDisplayName(row),
  email: row.buyer?.email ?? "-",
  school_year: schoolYearLabel(row),
});

export default function TutorStudents() {
  return (
    <TutorListPage
      title="Students"
      endpoint="tutor/students"
      columns={{
        id: "ID",
        course: "Course",
        name: "Student",
        email: "Email",
        school_year: "School year",
      }}
      transformRow={transformStudent}
      courseIdFilter
      studentFilters
      renderActions={(row) => {
        const buyerId = row.buyer_id || row.buyer?.id;
        if (!buyerId) return null;
        return (
          <Button
            size="small"
            variant="outlined"
            component={Link}
            to={`/tutor/students/${buyerId}`}
            startIcon={<VisibilityIcon />}
          >
            View
          </Button>
        );
      }}
    />
  );
}
